import { Box, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import HypeBanner from "components/HypeBanner"

import Microbanner from "./microbanner"
import SuperFilters from "./super-filters"
import Title from "./title"

const InternalHeading = ({ data, hypeBanner }) => {
  if (hypeBanner) {
    return <HypeBanner hype_project_name={hypeBanner} />
  }
  return (
    <Box borderBottom="1px solid #ebebeb">
      <Box px={2} py={4} textAlign="center">
        <Title data={data} />
      </Box>
      <SuperFilters data={data} />
      <MediaBox lessThan="tablet">
        <Microbanner />
      </MediaBox>
    </Box>
  )
}

const mapStateToProps = (state) => {
  return {
    hypeBanner: state.collection.banner,
  }
}

InternalHeading.propTypes = {
  data: PropTypes.object,
  hypeBanner: PropTypes.string,
}

const Heading = connect(mapStateToProps)(InternalHeading)

export default Heading
